import { createAsyncThunk } from "@reduxjs/toolkit";
import { createCouponAPI, deleteCouponAPI, fetchAllCouponsAPI } from "./couponsAPI";

// Fetch Coupons Thunk
export const fetchAllCoupons = createAsyncThunk("coupons/fetchEnquiries", async (_, {rejectWithValue}) => {
    try {
        const response = await fetchAllCouponsAPI()
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

// Additional thunks (e.g., deleteEnquiry,) can be added here similarly
export const deleteCoupon = createAsyncThunk("coupons/deleteCoupon", async (id, {rejectWithValue}) => {
    try {
        const response = await deleteCouponAPI(id)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})   

// // Update Enquiry Status Thunk
// export const updateEnquiryStatus = createAsyncThunk("enquiries/updateEnquiryStatus", async (body, {rejectWithValue}) => {
//     try {
//         const response = await updateEnquiryStatusAPI(body)
//         return response
//     } catch (error) {
//         return rejectWithValue(error)
//     }
// })

// Creating coupons
export const addCoupon = createAsyncThunk('coupons/addCoupon', async (body, { rejectWithValue }) => {
    try {
        const response = await createCouponAPI(body);
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
})